module.exports = __webpack_public_path__ + "fcf0bed18bb7094e2daa4e6df748beab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo_title_white.svg
// module id = 579
// module chunks = 1